@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.credit-card.title' | apContent }}</div>
}

@if (showMultipleInstallments()) {
    <credit-card-multiple-installments></credit-card-multiple-installments>
}
@if (showCreditCardAmount()) {
    <credit-card-amount></credit-card-amount>
}
@if (showTip()) {
    <credit-card-tip></credit-card-tip>
}
